import styled from 'styled-components';
import { colors } from '@/styles';

export const DevErrorBoundary = styled.div<{}>`
  position: relative;
  flex: 1;
`;

export const ErrorBoundaryWrapper = styled.div<{}>`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
`;

export const ErrorBoundary = styled.div<{}>`
  border-radius: 10px;
  position: absolute;
  border: 1px solid ${colors.secondary.lightGray3};
  padding: 20px;
  top: 100px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  max-height: calc(100% - 200px);
  width: calc(100% - 200px);
  max-width: 1440px;
  overflow-y: auto;
  background-color: ${colors.primary.white};
  z-index: 9999;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
`;

export const ErrorBoundaryHeader = styled.div<{}>`
  position: absolute;
  top: 1rem;
  right: 1rem;
  svg {
    cursor: pointer;
    color: ${colors.semantic.negative.primary};
    height: 24px;
    width: 24px;
  }
`;
